import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';

@Component({
    selector: 'fi-editor-page-header',
    templateUrl: './fi-editor-page-header.component.html',
    styleUrls: ['./fi-editor-page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-editor-page-header' },
    standalone: false,
})
export class FiEditorPageHeaderComponent {
    @Input() headerText: string;
    @Input() saveButtonTextId: string = 'common.save';
    @Input() cancelButtonTextId: string = 'common.cancel';
    @Input() menuItems: IItemsListAction2[] = [];
    @Input() isSaveButtonHidden: boolean = false;
    @Output() saveButtonClick = new EventEmitter<void>();

    protected isMenuHidden(): boolean {
        return !this.menuItems || this.menuItems.every((menuItem) => this.isMenuItemHidden(menuItem));
    }

    protected isMenuItemHidden(menuItem: IItemsListAction2): boolean {
        return menuItem.condition && !menuItem.condition();
    }

    protected goBack(): void {
        window.history.back();
    }

    protected onSaveButtonClick(): void {
        this.saveButtonClick.emit();
    }
}
